import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo API 레퍼런스",
  "description": "레퍼런스를 사용하여 Turborepo의 API에 대해 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo의 API 레퍼런스는 다음 섹션으로 나뉩니다:"
  }, {
    "heading": "플래그-구문",
    "content": "값이 필요한 옵션은 등호와 함께 전달할 수 있으며, 공백이 필요한 경우 따옴표를 사용합니다."
  }, {
    "heading": "--color",
    "content": "비대화형 터미널에서도 색상 사용을 강제합니다. 이는 색상 렌더링을 지원하는 GitHub Actions와 같은 CI 환경에서 색상 출력을 활성화하는 데 유용합니다."
  }, {
    "heading": "--no-color",
    "content": "대화형 터미널에서도 터미널 출력에서 색상을 억제합니다."
  }, {
    "heading": "--no-update-notifier",
    "content": "업데이트 알림을 비활성화합니다. 이 알림은 CI 환경에서 실행할 때 자동으로 비활성화되지만 이 플래그를 통해 수동으로 비활성화할 수도 있습니다."
  }, {
    "heading": "--no-update-notifier",
    "content": "또는 TURBO_NO_UPDATE_NOTIFIER 환경 변수를 사용하여 알림을 비활성화할 수 있습니다."
  }],
  "headings": [{
    "id": "설정",
    "content": "설정"
  }, {
    "id": "명령어",
    "content": "명령어"
  }, {
    "id": "패키지",
    "content": "패키지"
  }, {
    "id": "플래그-구문",
    "content": "플래그 구문"
  }, {
    "id": "전역-플래그",
    "content": "전역 플래그"
  }, {
    "id": "--color",
    "content": "--color"
  }, {
    "id": "--no-color",
    "content": "--no-color"
  }, {
    "id": "--no-update-notifier",
    "content": "--no-update-notifier"
  }]
};
import {Card, Cards} from '#components/card';
export const toc = [{
  depth: 2,
  url: "#설정",
  title: _jsx(_Fragment, {
    children: "설정"
  })
}, {
  depth: 2,
  url: "#명령어",
  title: _jsx(_Fragment, {
    children: "명령어"
  })
}, {
  depth: 2,
  url: "#패키지",
  title: _jsx(_Fragment, {
    children: "패키지"
  })
}, {
  depth: 2,
  url: "#플래그-구문",
  title: _jsx(_Fragment, {
    children: "플래그 구문"
  })
}, {
  depth: 2,
  url: "#전역-플래그",
  title: _jsx(_Fragment, {
    children: "전역 플래그"
  })
}, {
  depth: 3,
  url: "#--color",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--color"
    })
  })
}, {
  depth: 3,
  url: "#--no-color",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--no-color"
    })
  })
}, {
  depth: 3,
  url: "#--no-update-notifier",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--no-update-notifier"
    })
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Turborepo의 API 레퍼런스는 다음 섹션으로 나뉩니다:"
    }), "\n", _jsx(_components.h2, {
      id: "설정",
      children: "설정"
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "turbo.json 설정하기",
        href: "/docs/reference/configuration",
        description: "`turbo`의 동작을 설정합니다."
      }), _jsx(Card, {
        title: "패키지 설정",
        href: "/docs/reference/package-configurations",
        description: "패키지에 특정한 설정을 만듭니다."
      }), _jsx(Card, {
        title: "시스템 환경 변수",
        href: "/docs/reference/system-environment-variables",
        description: "환경 변수를 사용하여 `turbo`의 동작을 변경합니다."
      }), _jsx(Card, {
        title: "파일 glob 사양",
        href: "/docs/reference/globs",
        description: "`turbo`가 사용할 파일을 정의합니다."
      })]
    }), "\n", _jsx(_components.h2, {
      id: "명령어",
      children: "명령어"
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "run",
        href: "/docs/reference/run",
        description: "`turbo`를 사용하여 작업을 실행합니다."
      }), _jsx(Card, {
        title: "watch",
        href: "/docs/reference/watch",
        description: "의존성을 인식하는 단일 프로세스 작업 감시자입니다."
      }), _jsx(Card, {
        title: "prune",
        href: "/docs/reference/prune",
        description: "대상 workspace에 대한 부분 monorepo를 생성합니다."
      }), _jsx(Card, {
        title: "boundaries",
        href: "/docs/reference/boundaries",
        description: "monorepo에서 모범 사례를 시행합니다."
      }), _jsx(Card, {
        title: "ls",
        href: "/docs/reference/ls",
        description: "monorepo의 패키지를 나열합니다."
      }), _jsx(Card, {
        title: "query",
        href: "/docs/reference/query",
        description: "monorepo에 대해 GraphQL 쿼리를 실행합니다."
      }), _jsx(Card, {
        title: "generate",
        href: "/docs/reference/generate",
        description: "새로운 앱과 패키지로 Turborepo를 확장합니다."
      }), _jsx(Card, {
        title: "login",
        href: "/docs/reference/login",
        description: "Remote Cache 제공자에 로그인합니다."
      }), _jsx(Card, {
        title: "logout",
        href: "/docs/reference/logout",
        description: "Remote Cache 제공자에서 로그아웃합니다."
      }), _jsx(Card, {
        title: "link",
        href: "/docs/reference/link",
        description: "저장소를 Remote Cache에 연결합니다."
      }), _jsx(Card, {
        title: "unlink",
        href: "/docs/reference/unlink",
        description: "Remote Cache에서 저장소 연결을 해제합니다."
      }), _jsx(Card, {
        title: "scan",
        href: "/docs/reference/scan",
        description: "Turborepo에 가장 빠른 기본값을 활성화합니다."
      }), _jsx(Card, {
        title: "bin",
        href: "/docs/reference/bin",
        description: "`turbo` 바이너리의 경로를 가져옵니다."
      }), _jsx(Card, {
        title: "telemetry",
        href: "/docs/reference/telemetry",
        description: "머신의 텔레메트리를 관리합니다."
      })]
    }), "\n", _jsx(_components.h2, {
      id: "패키지",
      children: "패키지"
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "create-turbo",
        href: "/docs/reference/create-turbo",
        description: "예제를 사용하여 Turborepo를 시작합니다."
      }), _jsx(Card, {
        title: "eslint-config-turbo",
        href: "/docs/reference/eslint-config-turbo",
        description: "`turbo.json`에 나열되지 않은 환경 변수를 찾습니다."
      }), _jsx(Card, {
        title: "turbo-ignore",
        href: "/docs/reference/turbo-ignore",
        description: "`turbo-ignore`를 사용하여 작업을 건너뜁니다."
      }), _jsx(Card, {
        title: "@turbo/gen",
        href: "/docs/reference/turbo-gen",
        description: "Turborepo 생성기의 타입 정의입니다."
      })]
    }), "\n", _jsx(_components.h2, {
      id: "플래그-구문",
      children: "플래그 구문"
    }), "\n", _jsx(_components.p, {
      children: "값이 필요한 옵션은 등호와 함께 전달할 수 있으며, 공백이 필요한 경우 따옴표를 사용합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "--opt"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "value"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "--opt"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"value with a space\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "--opt"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " value"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "--opt"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"value with a space\""
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "전역-플래그",
      children: "전역 플래그"
    }), "\n", _jsx(_components.h3, {
      id: "--color",
      children: _jsx(_components.code, {
        children: "--color"
      })
    }), "\n", _jsx(_components.p, {
      children: "비대화형 터미널에서도 색상 사용을 강제합니다. 이는 색상 렌더링을 지원하는 GitHub Actions와 같은 CI 환경에서 색상 출력을 활성화하는 데 유용합니다."
    }), "\n", _jsx(_components.h3, {
      id: "--no-color",
      children: _jsx(_components.code, {
        children: "--no-color"
      })
    }), "\n", _jsx(_components.p, {
      children: "대화형 터미널에서도 터미널 출력에서 색상을 억제합니다."
    }), "\n", _jsx(_components.h3, {
      id: "--no-update-notifier",
      children: _jsx(_components.code, {
        children: "--no-update-notifier"
      })
    }), "\n", _jsx(_components.p, {
      children: "업데이트 알림을 비활성화합니다. 이 알림은 CI 환경에서 실행할 때 자동으로 비활성화되지만 이 플래그를 통해 수동으로 비활성화할 수도 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: ["또는 ", _jsxs(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: [_jsx(_components.code, {
          children: "TURBO_NO_UPDATE_NOTIFIER"
        }), " 환경 변수"]
      }), "를 사용하여 알림을 비활성화할 수 있습니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
